<template>
  <div class="echart" id="myEcharts2"/>
</template>
<script>
import echarts from 'echarts'

export default {
  data(){
    return {
      charts:null,
    }
  },
  props:{
    xdata: {
      default: [],
    },
    ydata:{
      default: [],
    }
  },
  watch:{
    xdata:{
      handler(newVal, oldVal){
       if (this.charts) {
         if (newVal) {
           this.init()
         } else {
           this.init()
         }
       }else{
           this.init();
         }
       },
      deep: true //对象内部属性的监听，关键。
      }
    },
  methods:{
    init(){
      this.charts = echarts.init(document.getElementById('myEcharts2'));
      window.addEventListener('resize', this.charts.resize, false);
      this.charts.setOption({
        color:['#0bea9f'],
        grid:{
          top:"100px",
          left:"70px",
          right:"30px",
          bottom:"30px"
        },
        legend:{//折现图各颜色，所代表的信息
          // padding:5 ,//图例内边距，单位px，默认上下左右内边距为5
          // itemGap:10,//legend各个item之间的间隔，横向布局是为水平间隔，纵向布局为纵向间隔
          data:['客户订单'],
          orient:"horizontal",//布局方式，，默认为水平布局，可选为：‘horizontal’水平|‘vertical’垂直
        },
        tooltip: {
		  trigger: 'axis',
		  // formatter:'{c}万元'
        },
        xAxis: {
          type: 'category',
          data: this.xdata,
          axisTick:{
            show:false
          },
          axisLabel:{
            interval:0,
            color:'#555'
          },
          axisLine:{
            lineStyle:{
              color:'#797979'
            }
          },
        },
        yAxis: {
          type: 'value',
          axisTick:{
            show:false
          },
          axisLine:{
            show:false,
          },
          splitLine:{
            lineStyle: {
              color:['#AAAAAA'],
            }
		  },
		  axisLabel:{
            formatter:'{value}万元'
          },
        },
        series: [{
          name:'客户订单',
          data: this.ydata,
          smooth: true,
          type: 'bar',
          symbol:'circle',
          symbolSize:10,
          lineStyle: {
            color: '#0bea9f',
            width: 1,
          },
          barWidth:30,
        }]
      })
    },
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.charts.resize, false);
  },
}
</script>
<style lang="scss" scoped>
.echart{
  width: 100%;
  height: 100%;
}
</style>
